import { render } from "./Sentiment.vue?vue&type=template&id=353d6246&scoped=true"
import script from "./Sentiment.vue?vue&type=script&lang=js"
export * from "./Sentiment.vue?vue&type=script&lang=js"

import "./Sentiment.vue?vue&type=style&index=0&id=353d6246&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353d6246"]])

export default __exports__